import { axios } from '@/services/axios';

export const getTRSClusters = () => {
    const endpoint = '/TRSClusters';
    const res = axios.get(endpoint);
    return res;
};
